export default __webpack_public_path__ + "static/media/govt.061dc6d3.svg";